// T141 — pull all distinct http(s) URLs out of a pasted blob or the text of an
// uploaded .txt/.csv/.md file. Order-preserving + deduped; trailing sentence
// punctuation that isn't part of the URL is trimmed. Mirrors the backend
// services/jobFetch.js#extractUrls so client preview matches what the server
// will actually import.

export function extractUrls(text, { max = 200 } = {}) {
  if (!text || typeof text !== 'string') return [];
  const matches = text.match(/\bhttps?:\/\/[^\s<>"'`)\]]+/gi) ?? [];
  const seen = new Set();
  const out = [];
  for (const m of matches) {
    const cleaned = m.replace(/[.,;:!?]+$/, '').trim();
    if (!cleaned || seen.has(cleaned)) continue;
    seen.add(cleaned);
    out.push(cleaned);
    if (out.length >= max) break;
  }
  return out;
}
